export default __webpack_public_path__ + "static/media/studio-1.4637b672.jpg";